import React from "react";
import WarningIcon from "@mui/icons-material/Warning";
import {Stack, Typography, useMediaQuery} from "@mui/material";
import {baseTheme} from "../themes/baseTheme";

/**
 * プレビュートークンが無効（期限切れ・不正）なときの画面
 * サーバ（/viewer-api/info）が 403 を返した場合に表示する
 * @constructor
 */
export const PreviewExpired: React.FC = () => {
  const isSmallDisplay = useMediaQuery(baseTheme.breakpoints.down('sm'));

  return (
    <>
      <Stack
        alignItems="center"
        justifyContent="center"
        mt={20}
        spacing={2}
      >
        <WarningIcon
          sx={{ fontSize: 100 }}
          color="warning"
        />
        <Typography variant={isSmallDisplay ? 'h5' : 'h3'} textAlign="center">プレビューの有効期限が切れました。</Typography>
      </Stack>
      <Typography variant="subtitle1" textAlign="center">管理画面からもう一度プレビューを開いてください。</Typography>
    </>
  );
}
